import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import { toast } from "react-toastify";

import Keycap from "~/components/keyboard/Keycap";
import { BodyTextSmall } from "~/components/Typographies";
import { readGridCoachmarkSeen, writeGridCoachmarkSeen } from "~/helpers/gridCoachmark";
import { useAppSelector } from "~/hooks/reduxHooks";

const CoachmarkContent = () => (
	<Box sx={{ alignItems: "center", display: "flex", flexWrap: "wrap", gap: 0.75 }}>
		<BodyTextSmall>Press</BodyTextSmall>
		<Keycap binding="/" />
		<BodyTextSmall>to search ·</BodyTextSmall>
		<Keycap binding="?" />
		<BodyTextSmall>for shortcuts</BodyTextSmall>
	</Box>
);

const GridCoachmark = () => {
	const hasActiveGrid = useAppSelector((state) => state.fernieAction.activeGridDataKey !== null);
	const shownRef = useRef(false);

	useEffect(() => {
		if (!hasActiveGrid || shownRef.current) return;
		shownRef.current = true;
		if (readGridCoachmarkSeen()) return;
		writeGridCoachmarkSeen();
		toast.info(<CoachmarkContent />, { autoClose: 8000, icon: false });
	}, [hasActiveGrid]);

	return null;
};

export default GridCoachmark;
